import axios, { AxiosRequestConfig, CreateAxiosDefaults } from "axios";
import { getUserAuthToken, getWhoAmIToken } from "../utils/storageHelper";
import { Config } from "./config";
const userToken = getUserAuthToken();

const options: CreateAxiosDefaults = {
  // baseURL: config.BASE_URL,
  headers: {
    Authorization: `Bearer ${userToken}`,
  },
  timeout: 60000,
  withCredentials: true,
};
const instance = axios.create(options);

// Add a request interceptor
instance.interceptors.request.use(
  async (config: any) => {
    const authData = getUserAuthToken();
    const tokenData = authData ? authData : getWhoAmIToken();
    if (tokenData) {
      config.headers["Authorization"] = `Bearer ${tokenData}`;
      config.headers["Subscription"] = Config.Subscription;
    }

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }
    config.headers["Access-Control-Allow-Credentials"] = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

export const Get = (url: string, config?: AxiosRequestConfig<any>) => {
  return new Promise((resolve, reject) => {
    instance
      .get(url, config)
      .then((result) => {
        if (result.status === 200 || result.status === 201) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const GetImage = (url: string, config?: AxiosRequestConfig<any>) => {
  return new Promise((resolve, reject) => {
    instance
      .get(url, config)
      .then((result) => {
        if (result.status === 200 || result.status === 201) {
          const reader = new window.FileReader();
          reader.readAsDataURL(result.data);
          reader.onload = function () {
            const imageDataUrl = reader.result;
            resolve(imageDataUrl);
          };
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const Put = (
  url: string,
  data?: any,
  config?: AxiosRequestConfig<any>
) => {
  return new Promise((resolve, reject) => {
    instance
      .put(url, data, config)
      .then((result) => {
        if (result.status === 200 || result.status === 201) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};

export const Post = (
  url: string,
  data?: any,
  config?: AxiosRequestConfig<any>
) => {
  return new Promise((resolve, reject) => {
    instance
      .post(url, data, config)
      .then((result) => {
        if (result.status === 200 || result.status === 201) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};

export const Delete = (
  url: string,
  data?: any,
  config?: AxiosRequestConfig<any>
) => {
  return new Promise((resolve, reject) => {
    instance
      .delete(url, config)
      .then((result: any) => {
        if (result.status === 200 || result.status === 201) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const API = {
  Get,
  Put,
  Post,
  Delete,
  GetImage,
};
